<template>
    <van-popup v-model="popupVisible"
        position="center"
        :close-on-click-overlay="false"
        class="invite-poster-popup"
        closeable
        close-icon="close"
        :transition-appear="true"
        transition="fade"
        @close="closePopup">
        <!-- 顶部提示 -->
        <div class="top-tip">长按海报分享给好友</div>
        <div class="poster-wrap">
            <!-- 圆角包装器（用于显示效果） -->
            <div class="poster-capture-wrapper">
                <!-- 可被截图的区域（无圆角） -->
                <div ref="capture"
                    class="poster-capture"
                    @click.stop>
                    <img v-if="posterInfo.posterBg"
                        class="poster-bg"
                        :src="posterInfo.posterBg"
                        alt="poster"
                        @load="onBgLoad" />
                    <!-- 头像和昵称区域 - 左上角 -->
                    <div v-if="avatar || nickname"
                        class="user-info-block">
                        <img v-if="avatar"
                            class="user-avatar"
                            :src="avatar"
                            alt="avatar" />
                        <span v-if="nickname"
                            class="user-nickname">{{ nickname }}</span>
                    </div>
                    <div v-if="posterInfo.qrUrl"
                        class="qr-block">
                        <img class="qr-img"
                            :src="posterInfo.qrUrl"
                            alt="qr" />
                        <div class="qr-text">长按识别二维码为TA助力</div>
                    </div>

                </div>
                <!-- 生成后的海报图（base64），用于长按保存/分享 -->
                <img v-if="screenshot"
                    class="poster-result"
                    :src="screenshot"
                    alt="poster-result" />
            </div>
        </div>
    </van-popup>
</template>

<script>
import html2canvas from 'html2canvas';
import { Popup, Toast } from 'vant';

export default {
  name: 'invite-poster',
  components: {
    [Popup.name]: Popup,
  },
  data() {
    return {
      screenshot: '',
      bgLoaded: false,
      popupVisible: false,
      posterInfo: {
        posterBg: '', // 海报背景图
        qrUrl: '', // 二维码图片地址
      },
      avatar: 'https://hshop.honorfile.com/pimages//pages/cdnImages/67005181648718150076.png', // 默认HONOR LOGO
      nickname: '', // 用户昵称
    };
  },
  watch: {
    popupVisible(val) {
      if (!val) {
        // 关闭时清理
        this.screenshot = '';
        this.bgLoaded = false;
      }
    },
  },
  created() {
    const userInfo = sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {};
    this.nickname = userInfo.nickName || '';
  },
  methods: {
    onBgLoad() {
      this.bgLoaded = true;
      this.tryGenerate();
    },
    async tryGenerate() {
      // 需要：弹层已打开 + 背景已加载
      if (!this.popupVisible || !this.bgLoaded) return;
      const el = this.$refs.capture;
      if (!el) return;

      Toast.loading({ message: '海报生成中...', duration: 0, forbidClick: true });
      try {
        const canvas = await html2canvas(el, {
          useCORS: true,
          backgroundColor: null,
          width: 313,
          height: 462,
          scale: window.devicePixelRatio || 2,
          logging: false,
        });
        this.screenshot = canvas.toDataURL('image/png');
      } catch (e) {
        // 兼容失败场景
        console.error('海报生成失败', e);
        this.closePopup();
        Toast('海报生成失败，请稍后再试~');
      } finally {
        Toast.clear();
      }
    },
    openPopup(posterInfo) {
      this.posterInfo = JSON.parse(JSON.stringify(posterInfo));
      this.popupVisible = true;
    },
    closePopup() {
      this.popupVisible = false;
      this.posterInfo = {
        posterBg: '',
        qrUrl: '',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.invite-poster-popup {
  background: transparent !important;
}
.poster-wrap {
  width: 100%;
  padding: 12px 8px 16px;
  box-sizing: border-box;
}
.poster-capture-wrapper {
  width: 313px;
  height: 462px;
  border-radius: 15px;
  overflow: hidden;
}
.poster-capture {
  position: relative;
  width: 313px;
  height: 462px;
}
.poster-bg {
  width: 100%;
  height: 100%;
  display: block;
}
.user-info-block {
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.1);
  position: absolute;
  left: 0px;
  top: 0px;
  width: auto;
  padding: 6px;
  border-bottom-right-radius: 10px;
}
.user-avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 8px;
  border: 1px solid #ffffff;
}
.user-nickname {
  font-size: 14px;
  color: #ffffff;
  font-weight: 500;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.qr-block {
  position: absolute;
  top: 35%;
  transform: translate(50%, 0);
}
.qr-img {
  width: 160px;
  height: 160px;
  background: #fff;
}
.qr-text {
  font-size: 14px;
  line-height: 14px;
  text-align: center;
  letter-spacing: 0px;
  margin-top: 6px;
  color: #3d3d3d;
}
.poster-result {
  position: absolute;
  width: 313px;
  height: 462px;
  top: 32px;
  left: 10px;
  opacity: 0; /* 不影响用户视觉，仅提供可长按的图片层 */
}
.top-tip {
  text-align: center;
  font-size: 14px;
  color: white;
  font-weight: 500;
}

/deep/ .van-popup__close-icon--top-right {
  right: 10px;
  top: 3px;
}

/deep/ .van-popup__close-icon {
  font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/activity-boost/invite-poster.vue